import { render, staticRenderFns } from "./Spec.vue?vue&type=template&id=52d96f9c&scoped=true&"
import script from "./Spec.vue?vue&type=script&lang=js&"
export * from "./Spec.vue?vue&type=script&lang=js&"
import style0 from "./Spec.vue?vue&type=style&index=0&id=52d96f9c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d96f9c",
  null
  
)

export default component.exports